import { useState } from 'react'
import { useAuth } from '@/hooks/useAuth'

/**
 * Indirizzo a cui arriva un invio di test (#319): parte dall'email dell'utente
 * loggato, anche se l'utente arriva dopo il primo render, finché non viene
 * digitato altro. Il contatto scelto per le variabili non lo tocca mai: il
 * test non deve arrivare al prospect.
 */
export function useTestRecipientEmail() {
  const { user } = useAuth()
  const [typedEmail, setTypedEmail] = useState<string | null>(null)
  return [typedEmail ?? user?.email ?? '', setTypedEmail] as const
}
